<template>
  <div>
    <b-button type="is-dark" v-on:click="edit = true"
      >Produktionsverfahren</b-button
    >

    <b-modal :active.sync="edit" has-modal-card>
      <div class="modal-card produktionsverfahren" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Produktionsverfahren bearbeiten</p>
        </header>
        <section class="modal-card-body">
          <b-message type="is-info" size="is-small" style="margin-bottom: 8px;">
            Sollte eine Produktionsverfahren für das Equipment gesetzt sein,
            wird dieses für die Berechnung der Verpackungspreise verwendet. Die
            Produktionsverfahren der Basisverpackung werden in diesem Fall
            ignoriert. Wenn noch keine Produktionsverfahren erstellt wurden bzw.
            nach dem Löschen aller Produktionsverfahren, können die
            Produktionsverfahren aus der Basisverpackung übernommen werden.
            Unter der Tabelle mit den absoluten Preisen, gibt es eine weitere
            Tabelle "Differenzpreise", die einen Taschenrechner ersetzt. Über
            diese können Preise zu den Preisen in der obigen Tabelle addiert
            bzw. subtrahiert werden. Bei der Eintragung eines Wertes werden
            die entsprechenden absoluten Preise sofort aktualisiert.
          </b-message>

          <!-- Button für Basis-Verpackungspreise -->
          <b-button
            v-if="shouldShowBasisPreiseButton"
            type="is-info"
            icon-left="sync"
            @click="loadBasisVerpackungPreise"
            style="margin-bottom:15px;"
          >
            Tabelle aus Basis-Verpackung
          </b-button>

          <div class="columns">
            <div v-for="number in 4" class="column" style="text-align:left;">
              <h6 class="title is-6">Produktionsverfahren {{ number }}</h6>

              <div v-if="packageProductions.length < number">
                <b-button
                  icon-left="plus-circle"
                  v-on:click="addPackageProduction(number)"
                >
                  Hinzufügen
                </b-button>
              </div>

              <div v-if="packageProductions.length >= number">
                <b-field label="Hersteller">
                  <multiselect
                    class="is-small"
                    v-model="packageProductions[number - 1].producer"
                    :show-labels="false"
                    placeholder="Hersteller auswählen"
                    :options="allproducer"
                    :multiple="false"
                    track-by="id"
                    label="name"
                    :close-on-select="true"
                  ></multiselect>
                </b-field>
                <b-field label="Produktionszeit">
                  <b-numberinput
                    size="is-small"
                    v-model="packageProductions[number - 1].productiontime"
                  ></b-numberinput>
                </b-field>
                <b-field label="Addiere Produktionszeit">
                  <div class="field">
                    <b-checkbox
                      v-model="packageProductions[number - 1].addProductiontime"
                      true-value="true"
                      false-value="false"
                    >
                      <!--   {{packageProductions[number-1].addProductiontime}} -->
                    </b-checkbox>
                  </div>
                </b-field>
                <!--              <b-field label="Link Preisliste">
                                <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].producerPricelistURL"></b-input>
                              </b-field>
                              <b-field label="Link Druckvorgaben">
                                <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].printGuidelineURL"></b-input>
                              </b-field>-->
                <b-field label="Zoho-Code">
                  <b-input
                    maxlength="255"
                    size="is-small"
                    v-model="packageProductions[number - 1].zohoCode"
                    readonly="true"
                  ></b-input>
                </b-field>
                <b-field label="Material">
                  <multiselect
                    class="is-small"
                    v-model="packageProductions[number - 1].material"
                    :show-labels="false"
                    placeholder="Material auswählen"
                    :options="allmaterials"
                    :multiple="false"
                    track-by="id"
                    label="name"
                    :close-on-select="true"
                  ></multiselect>
                </b-field>
                <!--  <b-field label="Sonderinfo">
                    <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].specialInformation"></b-input>
                  </b-field>-->
                <!--  <b-field label="Bild">
                    <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].image"></b-input>
                  </b-field>
                  <b-field label="Code">
                    <b-input maxlength="255" size="is-small" v-model="packageProductions[number-1].code"></b-input>
                  </b-field>-->

                <!--<b-field label="Aufschlagsatzstaffel">
                  <multiselect class="is-small" v-model="packageProductions[number-1].extraCharge" :show-labels="false" placeholder="Aufschlagsatzstaffel auswählen" :options="allextracharge" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
                </b-field>-->

                <label class="label">Kosten nach Auflage</label>
                <div style="overflow: auto">
                  <b-field
                    v-for="(item, index) in packageProductions[number - 1]
                      .packageCharge"
                    v-if="index != 'id'"
                    :message="index"
                  >
                    <b-input
                      pattern="[+]?[0-9]*\.?[0-9]+"
                      size="is-small"
                      v-model="
                        packageProductions[number - 1].packageCharge[index]
                      "
                    ></b-input>
                  </b-field>
                </div>

                <!-- NEU: Differenzpreis-Tabelle -->
                <label class="label" style="margin-top:10px;"
                  >Differenzpreise</label
                >
                <div style="overflow: auto">
                  <b-field
                    v-for="(item, index) in filteredPackageCharge(number - 1)"
                    :key="`diff-${index}`"
                    :message="index"
                  >
                    <b-input
                      pattern="-?[0-9]*\.?[0-9]+"
                      size="is-small"
                      v-model="
                        packageProductions[number - 1].diffPackageCharge[index]
                      "
                      @input="onDiffPriceChanged(number - 1, index)"
                    ></b-input>
                  </b-field>
                </div>

                <!--<label class="label">ExtraCharge</label>
                <div style="max-height: 170px;overflow: auto">
                  <b-field v-for="(item, index) in packageProductions[number-1].extraCharge" v-if="index != 'id'" :message="index">
                     <b-numberinput size="is-small" v-model="packageProductions[number-1].extraCharge[index]"></b-numberinput>
                 </b-field>
               </div>-->

                <div style="margin-top:20px;">
                  <b-button
                    icon-left="minus-circle"
                    v-on:click="removeGameProduction(number)"
                  >
                    Entfernen
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <footer class="modal-card-foot">
          <b-button class="button is-primary" @click="saveAllPackageProduction"
            >Übernehmen</b-button
          >
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
const axios = require("axios");

import Multiselect from "vue-multiselect";

export default {
  props: ["selected", "packageId"],
  components: {
    Multiselect
  },
  data() {
    return {
      edit: false,
      //packageProductions: [],
      packageProductions: [],
      allproducer: [],
      allextracharge: [],
      allmaterials: [],
      loadingBasisPreise: false
    };
  },
  computed: {
    shouldShowBasisPreiseButton() {
      // Zeige den Button, falls es KEINE Preise (packageCharge) gibt ODER mindestens eine packageCharge leer ist
      return (
        this.packageProductions.length === 0 ||
        this.packageProductions.some(
          prod =>
            !prod.packageCharge || Object.keys(prod.packageCharge).length === 0
        )
      );
    }
  },
  watch: {
    selected(val) {
      this.packageProductions = val;
      this.preparePackageProductionsArray();
      console.log(this.packageProductions);
    },
    packageProductions(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    console.log("Component mounted3.");
    this.getProducer();
    this.getExtraCharge();
    this.getMaterials();
  },
  methods: {
    // ...deine bisherigen Methoden...
    onDiffPriceChanged(prodIndex, fieldKey) {
      // Hole das aktuelle Produktionsverfahren-Objekt
      const prod = this.packageProductions[prodIndex];

      // Sicherstellen, dass alle nötigen Objekte existieren
      if (!prod.basicPackageCharge) prod.basicPackageCharge = {};
      if (!prod.diffPackageCharge) prod.diffPackageCharge = {};
      if (!prod.packageCharge) prod.packageCharge = {};

      // Grundpreis holen (zur Not auf 0 fallbacken)
      const base = parseFloat(prod.basicPackageCharge[fieldKey]) || 0;
      // Differenzpreis holen (kann leer oder NaN sein)
      const diff = parseFloat(prod.diffPackageCharge[fieldKey]) || 0;

      // Absoluten Preis NEU berechnen (Grundwert + Differenz)
      prod.packageCharge[fieldKey] = (base + diff).toFixed(2);
    },

    // Beim Ändern eines Differenzpreises
    onDiffInput(value, productionIndex, priceKey) {
      // Wert in diffPackageCharge speichern
      if (!this.packageProductions[productionIndex].diffPackageCharge) {
        this.$set(
          this.packageProductions[productionIndex],
          "diffPackageCharge",
          {}
        );
      }
      this.$set(
        this.packageProductions[productionIndex].diffPackageCharge,
        priceKey,
        Number(value) || 0
      );
    },

    // Methode zum Rücksetzen der Differenzpreise
    resetDiffPrices(productionIndex) {
      this.packageProductions[productionIndex].diffPackageCharge = {};
    },
    // Filter, um 'id' auszuschließen – Vue empfiehlt dies!
    filteredPackageCharge(idx) {
      const obj = this.packageProductions[idx].packageCharge || {};
      return Object.keys(obj)
        .filter(k => k !== "id")
        .reduce((acc, k) => {
          acc[k] = obj[k];
          return acc;
        }, {});
    },
    // Füge Differenzpreise zur packageProductions hinzu (bei Bedarf anpassen/prüfen!)
    preparePackageProductionsArray() {
      this.packageProductions.forEach(prod => {
        if (!prod.basicPackageCharge) {
          prod.basicPackageCharge = { ...(prod.packageCharge || {}) }; // Sicherer Kopie
        }
        if (!prod.diffPackageCharge) {
          prod.diffPackageCharge = {}; // falls noch nicht vorhanden
        }
      });
    },
    // Wird aufgerufen, wenn in der Differenzpreis-Tabelle was eingetragen wurde
    /*  onDiffInput(value, prodIndex, chargeKey) {
        // Wert in diffPackageCharge zwischenspeichern (für Anzeige, falls weiter editiert wird)
        this.$set(
            this.packageProductions[prodIndex].diffPackageCharge,
            chargeKey,
            value
        );

        // Wert in Haupttabelle addieren: falls leer, als 0 behandeln
        const org = Number(this.packageProductions[prodIndex].packageCharge[chargeKey] || 0);
        const diff = Number(value || 0);
        // Addiere (bei Bedarf Überprüfung auf Float!)
        this.$set(
            this.packageProductions[prodIndex].packageCharge,
            chargeKey,
            (org + diff)
        );
      },*/
    getProducer: function() {
      var _this = this;
      axios
        .get("/api/producers", {
          withCredentials: true
        })
        .then(function(response) {
          console.log("PRODUCER");
          console.log(response.data);
          _this.allproducer = response.data;
          //_this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          //  _this.loading = false;
        })
        .then(function() {
          // always executed
        });
    },
    getMaterials: function() {
      var _this = this;
      axios
        .get("/api/materials", {
          withCredentials: true
        })
        .then(function(response) {
          console.log("MATERIALS");
          console.log(response.data);
          _this.allmaterials = response.data;
          //_this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          //  _this.loading = false;
        })
        .then(function() {
          // always executed
        });
    },
    getExtraCharge: function() {
      var _this = this;
      axios
        .get("/api/extracharge", {
          withCredentials: true
        })
        .then(function(response) {
          console.log("EXTRA CHARGE");
          console.log(response.data);
          _this.allextracharge = response.data;
          //_this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          //  _this.loading = false;
        })
        .then(function() {
          // always executed
        });
    },
    addPackageProduction(number) {
      var newPackageProd = _.cloneDeep(empyPackageProduction);
      newPackageProd.producer = this.allproducer[0];
      this.packageProductions.push(newPackageProd);
    },
    removeGameProduction: function(number) {
      console.log("Remove " + number);
      this.packageProductions.splice(number - 1, 1);
      //    this.gameProductions.push(newGameProd);
    },
    saveAllPackageProduction: function() {
      console.log(this.packageProductions);
      //Preise: Komma durch Punkt ersetzen
      /*  this.packageProductions.forEach(function(el,index,arr){
           console.log(arr);
           console.log(el.packageCharge);

           Object.keys(el.packageCharge).forEach(function(key) {

            console.log(key, el.packageCharge[key]);
            el.packageCharge[key] = el.packageCharge[key];
          });

        });*/
      console.log(this.packageProductions);

      this.$emit("input", this.packageProductions);
      this.edit = false;
    },
    async loadBasisVerpackungPreise() {
      this.loadingBasisPreise = true;
      try {
        const response = await axios.get(`/api/packagesnew/${this.packageId}`, {
          withCredentials: true
        });
        if (response.data && Array.isArray(response.data.packageProductions)) {
          // Klone alle Produktionen und entferne alle IDs!
          const basisProductions = response.data.packageProductions.map(
            prod => {
              const clone = { ...prod };
              delete clone.id;
              // Auch IDs in packageCharge und diffPackageCharge entfernen!
              if (
                clone.packageCharge &&
                typeof clone.packageCharge === "object"
              ) {
                delete clone.packageCharge.id;
              }
              if (
                clone.diffPackageCharge &&
                typeof clone.diffPackageCharge === "object"
              ) {
                delete clone.diffPackageCharge.id;
              }
              return clone;
            }
          );
          this.packageProductions = basisProductions;
          this.preparePackageProductionsArray();
        } else {
          this.$buefy.toast.open({
            message: "Keine Basis-Verpackung gefunden.",
            type: "is-danger"
          });
        }
      } catch (error) {
        this.$buefy.toast.open({
          message: "Fehler beim Laden der Basis-Verpackung.",
          type: "is-danger"
        });
      } finally {
        this.loadingBasisPreise = false;
      }
    }
  }
};

const empyPackageProduction = {
  packageCharge: {
    //  id: 0,
    pac100: null,
    pac150: null,
    pac200: null,
    pac250: null,
    pac300: null,
    pac400: null,
    pac500: null,
    pac750: null,
    pac1000: null,
    pac1500: null,
    pac2000: null,
    pac2500: null,
    pac3000: null,
    pac4000: null,
    pac5000: null,
    pac7500: null,
    pac10000: null,
    pac15000: null,
    pac20000: null,
    pac30000: null,
    pac50000: null,
    pac100000: null
  },
  productiontime: 0,
  producerPricelistURL: "string",
  printGuidelineURL: "string"
  //  specialInformation: "string"
  //  image: "string",
  //  code: "string"
};
</script>
<style lang="scss">
.produktionsverfahren .label {
  font-size: 14px;
}

.multiselect.is-small {
  min-height: 27px;
  font-size: 0.75rem;
  color: #363636;
}

.multiselect.is-small .multiselect__select {
  position: absolute;
  width: 40px;
  height: 27px;
}

.multiselect.is-small .multiselect__tags {
  min-height: 27px;
  display: block;
  padding: 4px 40px 0 4px;
}

.multiselect.is-small .multiselect__input,
.multiselect.is-small .multiselect__single {
  font-size: 0.75rem;
  margin-bottom: 3px;
}
</style>
